// Mapa canônico módulo (coluna `module` do catálogo) → slug kebab-case.
//
// O slug é, ao mesmo tempo, o prefixo dos endpoints operacionais
// (GET /v1/<slug>/accessible-structures, etc.) e a base da rota privada (/<slug>).
// Por isso a fonte única vive na camada de API (a mais baixa): a query operacional,
// o router e a apresentação na sidebar derivam o slug daqui — nunca o contrário
// (camada de API não importa componentes). Catálogo dos 12 módulos:
// docs/prd/operational-modules/operational-modules.md §4.
export const OPERATIONAL_MODULE_SLUGS: Record<string, string> = {
  General: "general",
  Monitoring: "monitoring",
  Inspection: "inspection",
  "Action plan": "action-plan",
  "Stability analysis": "stability-analysis",
  EoR: "eor",
  ATO: "ato",
  PSB: "psb",
  GISTM: "gistm",
  PAEBM: "paebm",
  "Dam Break Study": "dam-break-study",
  "Risk Analysis": "risk-analysis",
};

// Slug (sem barra) a partir do valor canônico `module`. `undefined` para módulo
// fora do catálogo conhecido pelo front (o catálogo pode crescer no backend).
export const getOperationalModuleSlug = (
  moduleKey: string,
): string | undefined => OPERATIONAL_MODULE_SLUGS[moduleKey];
